import { render, staticRenderFns } from "./task-accept.vue?vue&type=template&id=e59a9f94&"
import script from "./task-accept.vue?vue&type=script&lang=js&"
export * from "./task-accept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports